import * as React from 'react';

function SvgGooglePayColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 58 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.506 14.369v2.956h-.939v-7.3h2.49c.634 0 1.17.212 1.612.633.45.421.675.934.675 1.539 0 .619-.225 1.135-.675 1.55-.435.414-.972.621-1.611.621h-1.552zm0-3.446v2.549h1.572c.374 0 .684-.126.929-.378.251-.25.377-.55.377-.897 0-.34-.126-.635-.377-.887a1.226 1.226 0 00-.93-.388h-1.571zM33.507 12.167c.695 0 1.242.185 1.644.555.401.371.601.879.601 1.524v3.08h-.898v-.694h-.04c-.388.57-.905.856-1.551.856-.551 0-1.013-.163-1.383-.489a1.562 1.562 0 01-.557-1.224c0-.516.195-.927.587-1.233.391-.306.913-.459 1.566-.459.558 0 1.018.102 1.378.306v-.214c0-.327-.13-.603-.388-.83a1.33 1.33 0 00-.908-.342c-.524 0-.939.22-1.245.663l-.827-.52c.457-.653 1.13-.98 2.021-.98zm-1.215 3.629c0 .245.104.448.312.612.208.162.45.244.73.244.395 0 .746-.146 1.055-.438.31-.293.465-.635.465-1.029-.293-.232-.701-.347-1.225-.347-.38 0-.699.092-.954.276-.255.183-.383.41-.383.682z"
        fill="#5F6368"
      />
      <mask
        id="GooglePayColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={35}
        y={12}
        width={6}
        height={8}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.905 12.33h5.001v7.197h-5V12.33z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#GooglePayColour_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.906 12.33l-3.134 7.197h-.969l1.164-2.518-2.062-4.68h1.021l1.49 3.59h.02l1.45-3.59h1.02z"
          fill="#5F6368"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.712 13.732c0-.296-.025-.58-.073-.854h-3.96v1.616h2.269a1.94 1.94 0 01-.839 1.274v1.05h1.354c.792-.73 1.249-1.81 1.249-3.087z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.68 17.83c1.134 0 2.087-.371 2.783-1.013l-1.353-1.049c-.377.254-.862.402-1.43.402-1.095 0-2.024-.738-2.357-1.731H15.93v1.08a4.2 4.2 0 003.751 2.312z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.323 14.439a2.521 2.521 0 010-1.606v-1.08h-1.395a4.17 4.17 0 00-.447 1.883c0 .677.162 1.317.447 1.883l1.395-1.08z"
        fill="#FABB05"
      />
      <mask
        id="GooglePayColour_svg__b"
        maskUnits="userSpaceOnUse"
        x={15}
        y={9}
        width={8}
        height={4}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.929 9.442h6.56v3.391h-6.56V9.442z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#GooglePayColour_svg__b)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.68 11.102a2.28 2.28 0 011.611.629l1.198-1.197a4.037 4.037 0 00-2.809-1.092 4.2 4.2 0 00-3.751 2.31l1.394 1.081c.333-.994 1.262-1.731 2.357-1.731z"
          fill="#E94235"
        />
      </g>
    </svg>
  );
}

export default SvgGooglePayColour;
